import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { NewRequestFormComponent } from '../../components/new-request-form/new-request-form.component';
import { WizardStepsNavComponent } from '../../../shell/components/wizard-steps-nav/wizard-steps-nav.component';
import { SHARED_IMPORTS } from '../../../../../shared/modules/shared-imports.module';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { CreateInterventionRequest, InterventionProgressStep } from '../../../intervention.model';
import { InterventionStore } from '../../../intervention.store';

// The first step of the wizard: the request is logged and the case opens at its next step, Eligibility.
@Component({
  selector: 'app-intervention-create-page',
  imports: [RouterLink, NewRequestFormComponent, WizardStepsNavComponent, ...SharedMaterialUIModule, ...SHARED_IMPORTS],
  templateUrl: './intervention-create.page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class InterventionCreatePage {
  private readonly router = inject(Router);
  protected readonly store = inject(InterventionStore);

  // The steps of the wizard, none of them started yet: the request is the first one, and the case opens at the next when it is created.
  protected readonly steps: InterventionProgressStep[] = [
    { key: 'NewRequest', label: 'New request', state: 'InProgress' },
    { key: 'Eligibility', label: 'Eligibility', state: 'NotStarted' },
    { key: 'PresentingProblem', label: 'Presenting problem', state: 'NotStarted' },
    { key: 'ClinicalAssessment', label: 'Clinical assessment', state: 'NotStarted' },
    { key: 'FunctionalImpactAndRisk', label: 'Functional impact and risk', state: 'NotStarted' },
    { key: 'TreatmentPlanning', label: 'Treatment planning', state: 'NotStarted' },
    { key: 'ConsentAndPreferences', label: 'Referral preferences and consent', state: 'NotStarted' },
    { key: 'ReferralMatching', label: 'Referral matching', state: 'NotStarted' },
  ];

  constructor() {
    this.store.loadInterventionTypes();
  }

  protected save(request: CreateInterventionRequest): void {
    this.store.create(request, (item) => void this.router.navigate(['/interventions', item.id]));
  }
}
